import { useEffect } from "react";

import { canRun, held, loadChoice, wakeIfCached } from "./model";
import { askLog } from "../components/estateVoice";

/**
 * The butler, up before anybody asks for it.
 * ---------------------------------------------------------------------------
 * A model that has already been downloaded costs about a second to put on the
 * GPU and nothing at all to leave there, so the one it was last used with is
 * brought up when the app starts. That is what makes the ask worth having: by
 * the time somebody presses Ctrl+Shift+A and says a sentence, the thing that
 * has to understand it is already awake.
 *
 * It never downloads. A model that is not on this machine stays off it until
 * somebody presses the button on the Butler page that says how big it is.
 *
 * Mounted next to the routes rather than on the Butler page, for the same
 * reason the WebMCP tools are: asking happens everywhere.
 * ---------------------------------------------------------------------------
 */
export default function ButlerBoot() {
  useEffect(() => {
    if (!canRun() || held()) return undefined;
    let gone = false;

    /* after the first paint, not during it: the estate is what someone came
       for, and a GPU upload on the critical path would show */
    const at = setTimeout(async () => {
      const id = await wakeIfCached();
      if (gone) return;
      if (id) askLog(`the butler is awake · ${id}`);
      else askLog(`no model on this machine yet · the ask will use its own keywords (Butler: ${loadChoice()})`);
    }, 2500);

    return () => { gone = true; clearTimeout(at); };
  }, []);

  return null;
}
